function convertVideoUrl(youtubeUrl) {
    const pattern = /(?<=watch\?v=|\/videos\/|embed\/|youtu\.be\/|\/v\/|\/e\/|watch\?v%3D|watch\?feature=player_embedded&v=|%2Fvideos%2F|embed%2F|youtu\.be%2F|%2Fv%2F|\/live\/)[^#&?\n]*/;
    const match = youtubeUrl.match(pattern);
    const videoId = match ? match[0] : null;
    
    return videoId ? `https://www.youtube.com/watch?v=${videoId}` : null;
}

export default convertVideoUrl;